var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarbonProject = function SvgCarbonProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5H16.11L5 20l7.5 23H35l8-15.5zM33 40H15l-3.191-9.574 22.834-9.766 4.857 7.113zM13.835 13.09 17.5 8H26l6.92 10.134-9.95 4.256zM8.5 20.5l3.556-4.939 7.952 8.095-9.151 3.914z"
  })));
};
export default SvgCarbonProject;